import React from "react"
import { Flex, Input, Select } from "antd"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { Text } from "ui/Typography"
import styles from "./index.module.css"

const ReasonSection = ({ cancelReasons, reasonsLoading, reasonsFailed, selectedReason, setSelectedReason, reasonError, setReasonError, isOtherSelected, otherReason, setOtherReason, otherReasonError, setOtherReasonError }) => {
  const { t } = useTranslation()
  return (
    <Flex vertical gap={6} className={styles.reasonSection}>
      <Text strong>{t("bookings.cancel_modal.reason_title")}</Text>
      {reasonsFailed ? (
        <Text className={styles.errorText}>{t("bookings.cancel_modal.reason_load_error")}</Text>
      ) : (
        <>
          <Select
            placeholder={t("bookings.cancel_modal.reason_placeholder")}
            value={selectedReason}
            loading={reasonsLoading}
            disabled={reasonsLoading}
            onChange={(value) => {
              setSelectedReason(value)
              setOtherReason("")
              setOtherReasonError("")
              if (reasonError) setReasonError("")
            }}
            options={(cancelReasons || []).map((r) => ({ value: r.id, label: r.reason }))}
            status={reasonError ? "error" : ""}
            style={{ width: "100%" }}
          />
          {reasonError && <Text className={styles.errorText}>{reasonError}</Text>}
          {isOtherSelected && (
            <Flex vertical gap={4}>
              <Input.TextArea
                placeholder={t("bookings.cancel_modal.other_reason_placeholder")}
                value={otherReason}
                onChange={(e) => { setOtherReason(e.target.value); if (otherReasonError) setOtherReasonError("") }}
                rows={3}
                status={otherReasonError ? "error" : ""}
              />
              {otherReasonError && <Text className={styles.errorText}>{otherReasonError}</Text>}
            </Flex>
          )}
        </>
      )}
    </Flex>
  )
}

ReasonSection.propTypes = {
  cancelReasons: PropTypes.array,
  reasonsLoading: PropTypes.bool,
  reasonsFailed: PropTypes.bool,
  selectedReason: PropTypes.number,
  setSelectedReason: PropTypes.func.isRequired,
  reasonError: PropTypes.string,
  setReasonError: PropTypes.func.isRequired,
  isOtherSelected: PropTypes.bool,
  otherReason: PropTypes.string,
  setOtherReason: PropTypes.func.isRequired,
  otherReasonError: PropTypes.string,
  setOtherReasonError: PropTypes.func.isRequired
}

export default ReasonSection
